<div id="security-container" class="container">
  <div class="row">
    <!-- Left Column: Change Password (30%) -->
    <div class="col-md-4 mb-4">
      <mat-card appearance="outlined">
        <form [formGroup]="password_form" method="post" (ngSubmit)="changePassword($event)">
          <mat-card-title>Change Password</mat-card-title>
          <mat-card-content>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>Current Password</mat-label>
                <input matInput type="password" formControlName="current_password" autocomplete="off"/>
              </mat-form-field>
            </div>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>New Password</mat-label>
                <input matInput type="password" formControlName="new_password" required
                  validateEqual="confirm_password" autocomplete="off"/>
              </mat-form-field>
            </div>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>Confirm Password</mat-label>
                <input matInput type="password" formControlName="confirm_password"
                  required validateEqual="new_password" reverse="true" autocomplete="off"/>
              </mat-form-field>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <p>
              <button mat-raised-button color="primary" type="submit"
                [disabled]="!password_form.valid">Save</button>
            </p>
            <nexus-form-result [model]="password_result_model"></nexus-form-result>
            <div class="alert alert-warning" *ngIf="(!password_form.valid && (showPasswordErrors || showConfirmPasswordErrors))">
              <ul>
                <ng-container *ngIf="showPasswordErrors">
                  <li [class.valid]="passwordErrors?.hasUpperCase"><fa-icon [icon]="passwordErrors?.hasUpperCase ? faCheckCircle : faTimesCircle"></fa-icon>Contains Uppercase Letter</li>
                  <li [class.valid]="passwordErrors?.hasLowerCase"><fa-icon [icon]="passwordErrors?.hasLowerCase ? faCheckCircle : faTimesCircle"></fa-icon>Contains Lowercase Letter</li>
                  <li [class.valid]="passwordErrors?.hasNumeric"><fa-icon [icon]="passwordErrors?.hasNumeric ? faCheckCircle : faTimesCircle"></fa-icon>Contains Number</li>
                  <li [class.valid]="passwordErrors?.hasSpecial"><fa-icon [icon]="passwordErrors?.hasSpecial ? faCheckCircle : faTimesCircle"></fa-icon>Contains Special Character</li>
                  <li [class.valid]="passwordErrors?.hasMinLength"><fa-icon [icon]="passwordErrors?.hasMinLength ? faCheckCircle : faTimesCircle"></fa-icon>Contains Minimum 12 Characters</li>
                </ng-container>
                <ng-container *ngIf="showConfirmPasswordErrors">
                  <li [class.valid]="confirmPasswordErrors"><fa-icon [icon]="confirmPasswordErrors ? faCheckCircle : faTimesCircle"></fa-icon>Confirm Password should match New Password</li>
                </ng-container>
              </ul>
            </div>
          </mat-card-actions>
        </form>
      </mat-card>
    </div>

    <!-- Right Column: MFA Settings (70%) -->
    <div class="col-md-8 mb-4">
      <app-mfasetting></app-mfasetting>
    </div>
  </div>
</div>
